const isDev =
  import.meta.env.VITE_VERCEL_ENV === 'development' || import.meta.env.VITE_VERCEL_ENV === 'preview'
const isStaging = import.meta.env.VITE_VERCEL_ENV === 'staging'
const isLive = import.meta.env.VITE_VERCEL_ENV === 'production'
const currentPhase = import.meta.env.VITE_VERCEL_ENV
const isLocalDev = process.env.NODE_ENV === 'development'

if (!isLive) {
  console.info('env', currentPhase)
}

const localStrapiApiUrl = import.meta.env.DEV
  ? import.meta.env.VITE_LOCAL_STRAPI_API_URL
  : undefined

const tossPaymentClientKey = isLive
  ? import.meta.env.VITE_VERCEL_TOSS_PAYMENT_CLIENT_KEY_LIVE
  : import.meta.env.VITE_VERCEL_TOSS_PAYMENT_CLIENT_KEY_TEST

const getPdfClientURL = () => {
  if (isLive) {
    return `https://mathflat-pdf-client.mathflat.com`
  }
  if (isStaging) {
    return `https://mathflat-pdf-client-staging.mathflat.com`
  }
  return `https://mathflat-pdf-client-dev.mathflat.com`
}

const MATHFLAT_BASE_URL_MAP = {
  development: 'https://teacher-dev.mathflat.com',
  preview: 'https://teacher-dev.mathflat.com',
  staging: 'https://teacher-staging.mathflat.com',
  production: 'https://teacher.mathflat.com',
} as const

const getMathflatBaseUrl = () => {
  if (isLocalDev) return 'http://localhost:4130'
  return (
    MATHFLAT_BASE_URL_MAP[currentPhase as keyof typeof MATHFLAT_BASE_URL_MAP] ??
    MATHFLAT_BASE_URL_MAP.development
  )
}

export const envUtils = {
  isDev,
  isStaging,
  isLive,
  currentPhase,
  getPdfClientURL,
  getMathflatBaseUrl,
  isLocalDev,
  localStrapiApiUrl,
  tossPaymentClientKey,
}
